import { Chart } from 'chart.js';
import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { TDashletValueBreakdownResponseData } from '../../dashboard.consts';
import { TDashletGraphOptions } from '../../dashlet-graph.model';
import { formatGraphNumericalValue } from './utils/format-graph-numerical-value';

const fontColor = '#586378';

export function generateValueBreakdownDoughnutGraphOptions(
  isMobile: boolean,
  isExport: boolean,
  unit: string,
  decimalPlaces: number,
  response: TDashletValueBreakdownResponseData,
  currencyCode?: string,
): TDashletGraphOptions {
  const fontSize = isExport ? 42 : 12;
  const fontFamily = getFontFamily();

  if (!isMobile) {
    return {
      devicePixelRatio: window.devicePixelRatio,
      layout: {
        padding: {
          top: isExport ? 100 : 20,
        },
      },
      plugins: {
        legend: {
          display: true,
          onClick: null,
          position: 'right',
          labels: {
            font: {
              size: fontSize,
              color: fontColor,
              family: fontFamily,
            },
            generateLabels: function (chart) {
              const maxLength = isExport ? 100 : 30; // Maximum characters before truncating
              const original =
                Chart.overrides[chart.config.type].plugins.legend.labels.generateLabels;
              const labels = original(chart);

              labels.forEach((label) => {
                label.value = response.data[label.text];
                const valueString = ` (${formatGraphNumericalValue(label.value, decimalPlaces, currencyCode, unit)})`;
                label.valueString = valueString;

                label.originalText = label.text;
                if (label.text.length > maxLength) {
                  label.text = label.text.substring(0, maxLength - 1) + '…' + valueString;
                } else {
                  label.text = label.originalText + valueString;
                }
              });

              return labels.sort((a, b) => {
                const aValue = a.value;
                const vValue = b.value;
                return aValue < vValue ? 1 : aValue > vValue ? -1 : 0;
              });
            },
          },
        },
        tooltip: {
          enabled: true,
          callbacks: {
            title: function (context): string {
              return '';
            },
            label: function (context): string {
              return context.label || '';
            },
          },
        },

        datalabels: {
          display: (value) => false,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      cutout: '55%',
    };
  } else {
    return {
      devicePixelRatio: window.devicePixelRatio,
      layout: {
        padding: {
          top: isExport ? 100 : 20,
        },
      },
      plugins: {
        legend: {
          display: true,
          onClick: null,
          position: 'bottom',
          labels: {
            font: {
              size: fontSize,
              color: fontColor,
              family: fontFamily,
            },
          },
        },
        tooltip: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem) {
              return '';
            },
          },
        },
        datalabels: {
          display: (value) => false,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      cutout: '55%',
    };
  }
}
